import Compteur from "../../../../../common/CarteLead/Compteur";
import { nbTachesFaites } from "../../../../../common/CarteLead/tachesResume";

// Compteurs affichés à côté des sections d'un lead entreprise ou DOMI, sur la
// barre d'accès de la carte comme dans les onglets du panneau.
export const extrasOnglets = (lead) => {
  const taches = lead.tasks || [];
  const nbCommentaires = (lead.comments || []).length;
  const nbLiees = lead.nbLinkedLeads || 0;
  return {
    commentaires: <Compteur plein={nbCommentaires > 0}>{nbCommentaires}</Compteur>,
    taches: (
      <Compteur plein={nbTachesFaites(taches) > 0}>
        {nbTachesFaites(taches)}/{taches.length}
      </Compteur>
    ),
    liees: <Compteur plein={nbLiees > 0}>{nbLiees}</Compteur>,
  };
};
